<template>
  <div>
    <transition name="route" mode="out-in">
      <PreLoader v-if="allIsLoading" />
    </transition>
    <div class="section section--light" style="margin-top: 75px">
      <div class="container">
        <div class="section__header">
          <h1 class="section__title">Cookie</h1>
        </div>
        <div class="section__content">
          <p>
            In this section, we will explain the use of cookies on our website,
            <a href="#"></a><a href="#">The Ear</a><a href="#"></a>.We invite
            you to take a few minutes of your time to understand how cookies
            make your user experience smoother and more transparent.
          </p>

          <ol type="I">
            <li><strong>What is Cookie?</strong></li>
          </ol>

          <p>
            Cookies are small pieces of text sent by your web browser to a
            website you visit. They are stored in your browser and allow the
            website or third parties to recognize you, making your future visits
            easier and the service more useful. Usually, cookies do not contain
            personally identifiable information, but the personal information we
            store can be linked to cookie data. If cookies contain personal
            data, the same terms as the Privacy Policy apply. Cookies can be
            divided into 'session' or 'persistent' based on their duration.
            Session cookies last until the browser is open and expire when
            closed, while persistent cookies expire at a specific time or if
            manually deleted, depending on which event occurs first.
          </p>

          <ol type="I" start="2">
            <li><strong>List of Cookies</strong></li>
          </ol>

          <p>
            The following table indicates the Cookies used on our site and their
            respective purposes:
          </p>

          <figure class="wrapper-table">
            <table class="table_information">
              <tbody>
                <tr>
                  <td><strong>Cookie</strong></td>
                  <td><strong>Purpose</strong></td>
                </tr>
                <tr>
                  <td>__ga</td>
                  <td>Cookie of Google Analytics</td>
                </tr>
                <tr>
                  <td>age_validity</td>
                  <td>
                    Retention of information about your minimum age requirements
                  </td>
                </tr>
                <tr>
                  <td>is_Cookie_Accepted , is_Cookie_rejected</td>
                  <td>
                    Storage of information on the user's consent to the cookie
                    use policy
                  </td>
                </tr>
                <tr>
                  <td>cookie_choice_expire</td>
                  <td>
                    Storing information relating to the duration of the cookie.
                    (We store the cookie for 1 year (365 days)).
                  </td>
                </tr>
              </tbody>
            </table>
          </figure>

          <p></p>

          <ol type="I" start="3">
            <li><strong>How to manage Cookies?</strong></li>
          </ol>

          <p>
            Most web browsers allow you to control Cookies via settings. You can
            disable Cookies, configure the browser to notify you when they are
            sent or delete them completely. However, please note that disabling
            the Cookies may require manual adjustment of preferences every time
            you visit a website or use online services. For further information
            on Cookies, how to manage and delete them, visit
            <a href="https://www.aboutcookies.org/">www.aboutcookies.org</a> o
            <a href="https://www.allaboutcookies.org/"
              >www.allaboutcookies.org</a
            >.
          </p>

          <p>
            We ask for your consent for Cookies through a pop-up visible when
            accessing the site.
          </p>

          <ol type="I" start="4">
            <li>
              <strong>Changes to the cookie use policy</strong>
            </li>
          </ol>

          <p>
            Over time, we may be required to change ours policy on the use of
            Cookies. We will notify you if there are any changes significant,
            but we recommend that you check this regularly Information to ensure
            you have the most up-to-date version.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PreLoader from "@/components/Global/PreLoader.vue";
export default {
  name: "Cookie_Page",
  components: {
    PreLoader,
  },
  data() {
    return {
      lang: localStorage.getItem("language") ?? "en",
      allIsLoading: true,
    };
  },
  methods: {
    timeout() {
      document.body.style.overflow='hidden';
      document.documentElement.style.overflow='hidden';
      setTimeout(() => {
        document.body.style.overflow='';
        document.documentElement.style.overflow='';
        this.allIsLoading = false;
      }, 1500);
    },
    setMetaTags() {
      const title = "The Ear | Cookie";
      const metaDescription =
        "Cookie Policy – Your Sweet Path to a Better Online Experience.";

      document.title = title;

      const metaDescriptionTag = document.querySelector(
        'meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.setAttribute("content", metaDescription);
      } else {
        const newMetaTag = document.createElement("meta");
        newMetaTag.name = "description";
        newMetaTag.content = metaDescription;
        document.head.appendChild(newMetaTag);
      }
    },
  },
  created() {
    let lang = localStorage.getItem("language") ?? "en";
    this.$router.push({ params: { lang: lang } });
    this.setMetaTags();
    this.timeout();
  },
};
</script>

<style scoped>
.section--light {
  background-color: #fff;
}
.section {
  padding: 60px 0;
  text-align: center;
}

.container {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.section--light .section__header:after {
  border-bottom: 1px solid #191b37;
}
.section__header:after {
  content: "";
  display: block;
  width: 150px;
  margin: 0 auto;
}

.section__header {
  margin: 0 0 40px;
}

.section--light .section__title {
  color: #191b37;
}

.section--light .section__header:after {
  border-bottom: 1px solid #191b37;
}

.section__content {
  text-align: left;
  vertical-align: top;
  line-height: 1.75 !important;
}

.section__title {
  font-size: 35px;
  text-transform: uppercase;
  font-weight: 900;
  font-family: "Montserrat", sans-serif;
}

p {
  margin: 0 0 15px;
  font-size: 16px;
}

.section__content ol,
.section__content ul {
  padding-left: 0px;
  padding-top: 10px;
  font-size: 16px;
}

.wrapper-table {
  overflow-x: auto;
}
.section__content table td {
  padding: 4px 8px;
  border: 2px solid cornflowerblue;
  font-size: 16px;
}

.table_information {
  width: 100%;
}

@media (max-width: 576px) {
  .section {
    padding: 30px 15px;
  }
  .container {
    margin: 0px 10px;
  }
}
</style>
